import React from "react";

import Select from "react-select";
// import "../../../../../styles/scss/_vendor/react-select.min.css";

import { FormInput } from "./FormInput";

import { func_validation } from "functions";



/* Props 
 * {
 *      // Label
 *      isInputOptional: false,
 *      isLabelOptional: false,
 *      inputLabel: "", 
 *      inputSideLabel: "", 
 * 
 *      // Input
 *      inputName: "",
 *      inputValue: "",
 *      inputOptions: [ { label: "", value: "" } ],
 *
 *      // Group
 *      isInputGrouped: false,
 *      inputPrepend: "" | JSX,
 *      inputAppend: "" | JSX, 
 * 
 *      // Input Options
 *      isInputDisabled: false, 
 *      isInputSearchable: false, 
 *      isInputClearable: false,
 * 		isInputMulti: false,
 * 		inputPlaceholder: "",
 * 
 *      // Input Validation
 *      isInputValueTrim_onChange: false,
 * 
 *      // Input Propagation
 *      inputStateName: undefined,
 *      propagateValueChange: (inputStateName, value_formatted)=>{},
 *      handleDropdownChangeExtend: (selection_new)=>{},
 * 
 *      // Error Display
 *      isErrorOptional: false,
 *      isFormSubmissionAttempted: false,
 * 
 *      // Error Checking
 *      customErrorMsgDefault: "",
 *      customErrorValidation: undefined,
 *      customErrorMsg: "",
 * 
 *      // Custom Error
 *      isInputHasError: false,
 *      customErrorDisplayArray: [{ isError: true|false, errorMsg: "" }],
 * 
 *      // Others
 *      className: "",
 *      customInputClassName: "",
 *      customPrependClassName: "",
 *      customAppendClassName: "",
 *      formInputCustomTheme: "component-formInputTheme_default",
 *      isMarginBtmOptional: false,
 *      inputCustomOptions: {},
 * }
 */

class FormInput_selectPresentation extends React.Component {
	constructor(props) {
        super(props);
        this.state = {
        };
        
		this.handleDropdownChange = this.handleDropdownChange.bind(this);
		this.handleDropdownChangeMulti = this.handleDropdownChangeMulti.bind(this);
    }

    handleDropdownChange(selection_new) {
        const { inputStateName, isInputValueTrim_onChange } = this.props;

        if (func_validation.isNotNullUndefined(selection_new) && 
            func_validation.isNotNullUndefined(selection_new.value)) {

            // Value
            let value_formatted = func_validation.getObjectPropertyValue(selection_new, "value", "");
            if (isInputValueTrim_onChange) value_formatted = func_validation.getTrimmedString(value_formatted);

            // Update parent state
            if (this.props.propagateValueChange) this.props.propagateValueChange(inputStateName, value_formatted);

            // Extension
            if (this.props.handleDropdownChangeExtend) this.props.handleDropdownChangeExtend(selection_new);
        }
    }

    handleDropdownChangeMulti(selectionArray_new) {
        const { inputStateName, isInputValueTrim_onChange } = this.props;
		
        let selectionArray = [];
		if (func_validation.isArrayNotEmpty(selectionArray_new)) {
			selectionArray_new.map((selection)=>{
				if (func_validation.isNotNullUndefined(selection) && 
					func_validation.isNotNullUndefined(selection.value)) {
					
					// Value
					let value_formatted = func_validation.getObjectPropertyValue(selection, "value", "");
					if (isInputValueTrim_onChange) value_formatted = func_validation.getTrimmedString(value_formatted);

					// Add into array
					selectionArray.push(value_formatted);
				}
			});
		}

		// Update parent state
		if (this.props.propagateValueChange) this.props.propagateValueChange(inputStateName, selectionArray);

		// Extension
		if (this.props.handleDropdownChangeExtend) this.props.handleDropdownChangeExtend(selectionArray);
    }

    render() {
        const { className, customInputClassName, customPrependClassName, customAppendClassName,
                formInputCustomTheme, isMarginBtmOptional, inputCustomOptions, 
                // Label
                isLabelOptional, inputLabel, inputSideLabel, isInputOptional, 
                // Group
                isInputGrouped, inputPrepend, inputAppend, 
                // Input
                inputName, inputValue, inputOptions, 
                isInputDisabled, isInputSearchable, isInputClearable, isInputMulti, inputPlaceholder, 
                // Error Checking
                isErrorOptional, 
                isFormSubmissionAttempted, 
                customErrorMsgDefault, customErrorValidation, customErrorMsg,
                isInputHasError, customErrorDisplayArray } = this.props;

        // Label
        let inputLabelDisplay = (
            <span className="component-formInput-label">
                {inputLabel}
                {(isInputOptional)?"":(<span className="component-formInput-labelAsterisk">*</span>)}
            </span>
        );

        // SideLabel
        let inputSideLabelDisplay = (
            <span className="component-formInput-sideLabel">
                {inputSideLabel}
            </span>
        );

        // Error Values
        let isError = false;
        let errorMsg = "";
        
        // Error Checking (Default)
        isError = (isFormSubmissionAttempted && !inputValue);
        errorMsg = (func_validation.isStringTrimNotEmpty(customErrorMsgDefault))?customErrorMsgDefault:"Input is Required";
        
        // Custom Error Checking (Empty)
        if (func_validation.isNotNullUndefined(customErrorValidation)) {
            isError = (customErrorValidation);
            errorMsg = (isError && func_validation.isStringTrimNotEmpty(customErrorMsg))?
                        customErrorMsg:errorMsg;
        }
        
        // Error Display
        let errorDisplay = (isError)?(<span className="component-formInput-errorMessage">{errorMsg}</span>):"";
        
        // Custom Error for Input
        let isInputHasError_formatted = func_validation.isBooleanTrueNotNullUndefined(isInputHasError);

        // Custom Error Display
        let customErrorDisplay = "";
        if (func_validation.isArrayNotEmpty(customErrorDisplayArray)) {
            customErrorDisplay = customErrorDisplayArray.map((customErrorDisplayItem, idx)=>{
                let isError_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "isError", false);
                let errorMsg_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "errorMsg", "");
                if (func_validation.isBooleanTrueNotNullUndefined(isError_custom) && 
                    func_validation.isStringTrimNotEmpty(errorMsg_custom)) {
                    return (<span className="component-formInput-errorMessage" key={idx}>{errorMsg_custom}</span>);
                }
            });
        }
        
        // Input Options
        let inputCustomOptions_formatted = (func_validation.isObjectNotEmpty(inputCustomOptions)?inputCustomOptions:{});
        
        // Input
        let inputDisplay_complex = (
            <Select className={"component-formInput-input "+
                                ((customInputClassName)?customInputClassName+" ":"")+
                                (((isError || isInputHasError_formatted) && !isErrorOptional)?"component-formInput-inputHasError ":"")+
                                ((isInputMulti)?"component-formInput-input_multi ":"")}
                name={inputName} value={inputValue} 
                options={(func_validation.isArrayNotEmpty(inputOptions)?inputOptions:[])}
                onChange={(val)=>{ (isInputMulti)?this.handleDropdownChangeMulti(val):this.handleDropdownChange(val); }} 
                disabled={(isInputDisabled)} 
                searchable={((isInputSearchable)?isInputSearchable:false)}
                clearable={((isInputClearable)?isInputClearable:false)}
                placeholder={(inputPlaceholder)?inputPlaceholder:"Select..."} 
                multi={(isInputMulti)?isInputMulti:false}

                {...inputCustomOptions_formatted}
            />
        );

        return (
            <FormInput className={""+((className)?className+" ":"")+
                                       ((formInputCustomTheme)?formInputCustomTheme+" ":"component-formInputTheme_default ")} 
                isMarginBtmOptional={isMarginBtmOptional}>
                
                <div className="component-formInputSelect">
                
                    {/* Label */}
                    {(isLabelOptional)?"":(
                        (inputSideLabel)?(
                            <div className="component-formInput-labelGroup d-flex align-items-center justify-content-between">
                                {inputLabelDisplay}
                                {inputSideLabelDisplay}
                            </div>
                        ):inputLabelDisplay
                    )}

                    {/* Input */}
                    {(isInputGrouped)?(
                        <div className="component-formInput-group d-flex align-items-center">
                            {/* Prepend */}
                            {(inputPrepend)?(
                                <div className={"component-formInput-prepend "+
                                                ((customPrependClassName)?customPrependClassName+" ":"")}>
                                    {inputPrepend}
                                </div>
                            ):""}

                            {/* Input */}
                            {inputDisplay_complex}

                            {/* Append */}
                            {(inputAppend)?(
                                <div className={"component-formInput-append "+
                                                ((customAppendClassName)?customAppendClassName+" ":"")}>
                                    {inputAppend}
                                </div>
                            ):""}
                        </div>
                    ):inputDisplay_complex}
                    
                    {/* Error Message */}
                    {(isErrorOptional)?"":(errorDisplay)}
                    
                    {/* Custom Error Message */}
                    {(customErrorDisplay)?customErrorDisplay:""}

                </div>
            </FormInput>
        );
    }
}



const FormInput_select = FormInput_selectPresentation;
export { FormInput_select };